import { Location } from '@cobliteam/common-types';
import { lazy } from '@cobliteam/lazy-with-retries';

const AccountPage = lazy(() => import('../pages/account'));
const FleetPage = lazy(() => import('../pages/fleet'));
const NotificationsPage = lazy(() => import('../pages/notifications'));
const UsersPage = lazy(() => import('../pages/users'));
const AlertsPage = lazy(() => import('../pages/alerts'));
const EventsPage = lazy(() => import('../pages/events'));
const CameraWifiPage = lazy(() => import('../pages/camera-wifi'));
const FaceIdSettingsPage = lazy(() => import('../pages/face-id'));

const routes = [
  {
    path: Location.CONFIG_ACCOUNT,
    component: AccountPage,
  },
  {
    path: Location.CONFIG_FLEET,
    component: FleetPage,
  },
  {
    path: Location.CONFIG_NOTIFICATIONS_CENTER,
    component: NotificationsPage,
  },
  {
    path: Location.CONFIG_USERS,
    component: UsersPage,
    hasGroupsRestriction: true,
  },
  {
    path: Location.CONFIG_ALERTS,
    component: AlertsPage,
    hasGroupsRestriction: true,
  },
  {
    path: Location.CONFIG_EVENTS_CONFIGURATION,
    component: EventsPage,
    hasGroupsRestriction: true,
  },
  {
    path: Location.CONFIG_CAMERA_WIFI_CONFIGURATION,
    component: CameraWifiPage,
    hasCameraFlag: true,
    hasGroupsRestriction: true,
  },
  {
    path: Location.CONFIG_FACE_ID,
    component: FaceIdSettingsPage,
    hasCameraFlag: true,
    hasGroupsRestriction: true,
  },
];

export default routes;
